// 注册 SvgIcon 组件
import Vue from 'vue'
import SvgIcon from '@/components/icons/SvgIcon'

import '@/components/icons/svg.scss'
// 全局注册组件
Vue.component('svg-icon', SvgIcon)

// 自动导入所有 SVG 图标
// 这里使用 webpack 的 require.context 来导入所有 SVG 文件
// 第一个参数是目录，第二个参数是是否查找子目录，第三个参数是匹配文件的正则表达式
const req = require.context('@/assets', false, /\.svg$/)

// 导入所有匹配的文件
const requireAll = requireContext => {
  const svgFiles = requireContext.keys()
  console.log('SVG files:', svgFiles) // 调试用，查看加载了哪些 SVG 文件
  return svgFiles.map(requireContext)
}

requireAll(req)

export default {
  install(Vue) {
    Vue.component('svg-icon', SvgIcon)
  }
} 